// Module
var code = "<div if=\"showProgressbar\" class=\"gc-progressbar\" role=\"progressbar\" aria-valuemin=\"{{ progressMin }}\" aria-valuemax=\"{{ progressMax }}\" aria-valuenow=\"{{ progress }}\" style=\"width:{{ progress }}%;\"></div>";
// Exports
export default code;